/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 17/9/2021
 * @Example
 */

import React, { useRef, useEffect, useState } from 'react';
import ActionToolbar from '../../../common/toolbar/action-toolbar';
import Config from '../../../../config/index';
import { browserHistory } from 'react-router';
import GridContainer from "../../../grid-container/grid-container";
import { Column } from "devextreme-react/data-grid";
import { Button, ButtonIcon, Dropdown, FormGroup, NumberInput, TreeView, Avatar } from 'diginet-core-ui/components';
import Filter from '../../../filter/filter';
import { useDispatch } from 'react-redux';
import * as generalActions from '../../../../redux/general/general_actions';
import _ from 'lodash';
import * as W39F3036Actions from '../../../../redux/W3X/W39F3036/W39F3036_actions';
import { makeStyles } from '@material-ui/core/styles';
import { LoadPanel } from "devextreme-react";
import History from '../../../libs/history';

const useStyles = makeStyles((theme) => ({
    formatCell: {
        backgroundColor: 'transparent',
        margin: '0 !important',
        paddingLeft: 10,
        paddingRight: 5,
        '& .DGN-UI-Dropdown-Form': {
            '&:before': {
                border: 'none !important',
            },
            '&:after': {
                border: 'none !important',
            }
        }
    },
    statisticGrid: {
        '& .dx-datagrid-header-panel': {
            display: 'none'
        }
    }
}));
const W39F3036 = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const FormID = "W39F3036";
    const Language = Config.language || "84";

    const filterCboEmployees = useRef({
        Type: "EmployeeID", timer: null, HostID: "", strSearch: "",
        skip: 0, limit: 50
    });

    const [iPermission, setIPermission] = useState({
        W39F3035: 0, W39F3037: 0, W39F3038: 0
    });
    const [dataCboEmployees, setDataCboEmployees] = useState({ rows: [], total: 0 });
    const [dataOrgChart, setDataOrgChart] = useState([]);
    const user = Config.getUser({ UserID: Config.profile.UserID });
    const [filterSearch, setFilterSearch] = useState({
        OrgChartID: user.OrgChartID ? [user.OrgChartID] : [],
        EmployeeID: '',
        ResultFrom: null,
        ResultTo: null
    });
    const [dataSource, setDataSource] = useState([]);
    const oldDataSouce = useRef(null);
    const [dataSourceStatistic, setDataSourceStatistic] = useState([]);
    const [column, setColumn] = useState([]);
    const [columnStatistic, setColumnStatistic] = useState([]);
    const [cbEvaluationType, setCbEvaluationType] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const refRateGrid = useRef(null);
    const refStatisticGrid = useRef(null);


    const getInfo = (flag) => {
        const { location } = props;
        if (location && location.state) {
            return {
                mode: location.state.mode ?? 'view',
                GoalPlanID: location.state.GoalPlanID,
                GoalPlanName: location.state.GoalPlanName,
                IsTransferred: location.state.IsTransferred || 0
            }
        } else {
            if (flag) {
                browserHistory.push(Config.getRootPath() + "W39F3035");
                return null;
            }
            return false;
        }
    };

    const loadPermission = () => {
        dispatch(generalActions.getPermission(["W39F3035", "W39F3037", "W39F3038"], (arrPer) => {
            let isPermission = {};
            arrPer.forEach(per => {
                if (per.hasOwnProperty('FormID') && per.hasOwnProperty('IsPermission')) {
                    isPermission[per.FormID] = per.IsPermission;
                }
            });
            setIPermission(isPermission);
        }));
    };

    useEffect(() => {
        if (!getInfo()) return;
        if (!iPermission.W39F3035) {
            loadPermission();
            return;
        }
        getGridData();
        getCbEvaluationType();
        /* eslint-disable */
    }, [iPermission])

    const loadCboEmployees = (isReset) => {
        const { HostID, Type, skip, limit, strSearch: search } = filterCboEmployees.current;
        const param = { HostID, Type, FormID, Language, skip, limit, search };
        dispatch(generalActions.getCboEmployees(param, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error || Config.lang("Loi_chua_xac_dinh"));
                return false;
            }
            const rows = data?.rows ? data.rows : data;
            setDataCboEmployees({
                rows: isReset ? rows : dataCboEmployees.rows.concat(rows),
                total: data.total
            })
        }));
    };

    const loadDataOrgChart = () => {
        dispatch(generalActions.getOrgCharts({ FormID }, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error);
                return false;
            }
            const dataSource = _generateDataOrg(data, "OrgChartID", "OrgChartParentID");
            setDataOrgChart(dataSource);
        }))
    };

    const _generateDataOrg = (dataSource, valueExpr, parentIdExpr) => {
        return dataSource.map((e) => {
            if (e[valueExpr] && e[parentIdExpr] && e[valueExpr] === e[parentIdExpr]) {
                delete e[parentIdExpr];
                e.expanded = true;
            } else if (!e[parentIdExpr]) {
                e.expanded = true;
            }
            return e;
        });
    };

    const onLoadDataFilter = () => {
        loadCboEmployees();
        loadDataOrgChart();
    }

    const filterChange = (key, e) => {
        if (!e) return;
        let value = _.get(e, "value", _.get(e, "target.value", ""));
        const isNumber = key === 'ResultFrom' || key === 'ResultTo';
        setFilterSearch({ ...filterSearch, [key]: isNumber ? Number(value) : value });
    }

    const renderFilterData = () => {
        return (
            <Filter
                isUseDDCore={true}
                openOnFieldClick={true}
                placeholder={Config.lang("Noi_dung_can_tim_kiem")}
                onOpenLoaded={onLoadDataFilter}

                renderFilter={() => {
                    return (
                        <div>
                            <Dropdown
                                dataSource={dataOrgChart}
                                valueExpr={"OrgChartID"}
                                displayExpr={"OrgName"}
                                label={Config.lang("Co_cau_to_chuc")}
                                keyExpr={'OrgName'}
                                multiple
                                value={filterSearch.OrgChartID}
                                clearAble
                                onChange={(e) => filterChange("OrgChartID", e)}
                            >
                                <TreeView
                                    allowSearch
                                    dataSource={dataOrgChart}
                                    disabledRelevantValue
                                    displayExpr={"OrgName"}
                                    id={"OrgChartID"}
                                    multiple
                                    expand={true}
                                    multipleValueMode="single"
                                    parentID={"OrgChartParentID"}
                                    value={filterSearch.OrgChartID}
                                    valueExpr={"OrgChartID"}
                                    onChange={(e) => filterChange("OrgChartID", e)}
                                />
                            </Dropdown>
                            <Dropdown
                                clearAble
                                // style={{ marginBottom: 10 }}
                                dataSource={_.get(dataCboEmployees, "rows", [])}
                                total={_.get(dataCboEmployees, "total", 0)}
                                skip={filterCboEmployees.current.skip}
                                limit={filterCboEmployees.current.limit}
                                value={filterSearch.EmployeeID}
                                // viewType={"outlined"}
                                valueExpr={"EmployeeID"}
                                keyExpr={"EmployeeName"}
                                searchDelayTime={1000}
                                label={Config.lang("Nhan_vien")}
                                // placeholder={Config.lang("Chon")}
                                displayExpr={"{EmployeeID} - {EmployeeName}"}
                                onChange={(e) => filterChange("EmployeeID", e)}
                                onInput={(e) => {
                                    filterCboEmployees.current.strSearch = e.target.value;
                                    filterCboEmployees.current.skip = 0;
                                    loadCboEmployees(true);
                                }}
                                onLoadMore={(e) => {
                                    filterCboEmployees.current.skip = e.skip;
                                    filterCboEmployees.current.limit = e.limit;
                                    loadCboEmployees();
                                }}
                            />
                            <FormGroup>
                                <NumberInput
                                    label={Config.lang('Tu')}
                                    value={filterSearch.ResultFrom}
                                    onChange={(e) => filterChange("ResultFrom", e)}
                                    style={{ width: '100%', marginRight: 10 }}
                                />
                                <NumberInput
                                    label={Config.lang('Den')}
                                    value={filterSearch.ResultTo}
                                    onChange={(e) => filterChange("ResultTo", e)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                            <div style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}>
                                <Button
                                    size={"medium"}
                                    color={"primary"}
                                    viewType={"outlined"}
                                    label={Config.lang("Tim_kiem")}
                                    startIcon={"Search"}
                                    onClick={() => getGridData(true)}
                                />
                            </div>
                        </div>
                    );
                }}
            />
        );
    };

    const checkNumber = (value) => {
        return typeof value === 'number';
    }

    const getGridData = (isSearch = false) => {
        if (isSearch) {
            if (checkNumber(filterSearch.ResultFrom) && checkNumber(filterSearch.ResultTo) &&
                filterSearch.ResultFrom > filterSearch.ResultTo) {
                Config.popup.show('INFO', Config.lang('Gia_tri_tu_phai_nho_hon_gia_tri_den'));
                return;
            }
        }
        let _OrgChartID = '(';
        filterSearch.OrgChartID.forEach((vl, i) => {
            _OrgChartID += (i > 0 ? ",'" : "'") + vl + "'";
        });
        _OrgChartID += ')';
        const params = {
            FormID, Language, GoalPlanID, ...filterSearch,
            OrgChartID: filterSearch.OrgChartID.length > 0 ? _OrgChartID : ''
        };
        setLoading(true);
        dispatch(W39F3036Actions.getGridData(params, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error);
                setLoading(false);
                return false;
            }
            setLoading(false);
            if (data?.data?.Rate.length > 0) {
                data.data.Rate.map((rs, i) => {
                    rs.STT = i + 1;
                    return rs;
                });
            }
            oldDataSouce.current = JSON.parse(JSON.stringify(data?.data?.Rate));
            setColumn(data.data.Column.filter(rs => rs.IsUsed));
            setDataSource(data.data.Rate);
            if (data.data.Statistic) {
                const column = removeDuplicates(data.data.Statistic, 'SDetailID');
                setColumnStatistic(column);
                const group = groupByField(data.data.Statistic, 'SCRefID');
                let dataFilter = [];
                Object.keys(group).forEach((rs, index) => {
                    dataFilter.push(group[rs]);
                });
                dataFilter.map(rs => {
                    rs['STotal'] = 0;
                    rs.data.forEach(item => {
                        rs[item.SDetailID] = item.SValue;
                        rs['STotal'] = rs['STotal'] + Math.abs(item.SValue);
                    });
                    delete rs.data;
                });
                setDataSourceStatistic(dataFilter);
            }
        }))
    }

    const getCbEvaluationType = () => {
        dispatch(W39F3036Actions.getFormData({ GoalPlanID }, (error, data) => {
            if (error) {
                Config.popup.show("ERROR", error);
                return false;
            }
            setCbEvaluationType(data.data);
        }))
    }

    const cellRenderEmloyee = (e) => {
        const { data } = e.row;
        const user = Config.getUser({ EmployeeID: data.EmployeeID });
        const { EmployeeID, UserPictureURL } = user;
        return (
            <div className={"display_row align-center"}>
                <Avatar hoverAble={false} readOnly
                    src={
                        UserPictureURL?.indexOf('http') < 0
                            ? Config.getCDNPath() + UserPictureURL
                            : UserPictureURL
                    }
                    width={24}
                    height={24}
                />
                <div className="pdl5">{EmployeeID} </div>
            </div>
        )
    }

    const renderColumn = () => {
        const rs = column.map((item, i) => {
            const { RefName, RefID, GroupMode } = item;
            if ((GroupMode === 0 && !iPermission.W39F3037) || (GroupMode === 1 && !iPermission.W39F3038)) {
                return;
            }
            const width = RefName.length > 20 ? 250 : 200;
            let fieldType = "string";
            let alignment = "left";
            switch (GroupMode) {
                case 0:
                    alignment = "left";
                    fieldType = "number";
                    break;
                case 1:
                    fieldType = "number";
                    alignment = "right";
                    break;
                case 2:
                    fieldType = "string";
                    break;
                default:
                    break;
            }
            return (
                <Column
                    key={i}
                    caption={RefName}
                    dataField={RefID}
                    width={width}
                    alignment={alignment}
                    dataType={fieldType}
                    {...(GroupMode === 0 ? {
                        allowEditing: iPermission.W39F3037 > 2,
                        cellRender: e => {
                            const { data } = e;
                            const item = cbEvaluationType.find(rs => rs.Value === data[RefID]);
                            return item && item.EvaluationTypeName;
                        },
                        editCellRender: (e) => {
                            const { data } = e;
                            return <Dropdown
                                dataSource={cbEvaluationType}
                                valueExpr={"Value"}
                                displayExpr={"EvaluationTypeName"}
                                keyExpr={'Value'}
                                value={e.value}
                                className={classes.formatCell}
                                renderSelectedItem={e => (e.data.EvaluationTypeName)}
                                onChange={(vl) => {
                                    if (vl.value === data[RefID]) return;
                                    e.component.cellValue(e.rowIndex, e.columnIndex, vl.value);
                                }}
                            />
                        }
                    } : GroupMode === 1 ? {
                        allowEditing: iPermission.W39F3038 > 2,
                    } : {})
                    }
                />
            )
        });
        return rs;
    }

    const renderColumnStatistic = () => {
        const rs = columnStatistic.map((item, i) => {
            const { SDetailID, SEvaluationTypeName } = item;
            return (
                <Column
                    key={i}
                    caption={SEvaluationTypeName}
                    dataField={SDetailID}
                    width={100}
                    alignment='right'
                    dataType='number'
                />
            )
        });
        return rs;
    }

    const onSave = (goBack = false) => {
        if (refRateGrid.current) refRateGrid.current.dataGrid.instance.saveEditData();
        const params = {
            Language, FormID, GoalPlanID,
            Data: JSON.stringify(dataSource)
        };
        setLoading(true);
        dispatch(W39F3036Actions.onSave(params, (error, data) => {
            if (error) {
                setLoading(false);
                Config.popup.show("ERROR", error);
                return false;
            }
            saveHistory();
            if (goBack) {
                browserHistory.goBack();
                return;
            }
            getGridData();
            setIsUpdated(false);
            Config.notify.show('success', Config.lang("Luu_thanh_cong"), 2000);
        }))
    }

    const saveHistory = async () => {
        if (GoalPlanID) {
            //Caption master
            const captions = {
                GoalPlanName: "Ten_bang_tong_hop",
            };
            //caption detail
            const captionTCXL = {
                EmployeeID: Config.lang("Ma_nhan_vien"),
                EmployeeName: Config.lang("Ten_nhan_vien"),
            };
            const captionTCS = {
                EmployeeID: Config.lang("Ma_nhan_vien"),
                EmployeeName: Config.lang("Ten_nhan_vien"),
            };
            const captionC = {
                EmployeeID: Config.lang("Ma_nhan_vien"),
                EmployeeName: Config.lang("Ten_nhan_vien"),
            };
            column.map(rs => {
                if (rs?.RefID.includes("CSummaryRef")) {
                    captionTCXL[rs.RefID] = rs.RefName;
                }
                if (rs?.RefID.includes("NumSummaryRef")) {
                    captionTCS[rs.RefID] = rs.RefName;
                }
                if (rs?.RefID.includes("StrSummaryRef")) {
                    captionC[rs.RefID] = rs.RefName;
                }
            });

            const _dataSource = refRateGrid.current.dataGrid.instance.option("dataSource");
            const options = {
                data: {
                    GoalPlanName: GoalPlanName
                },
                dataCompare: {
                    GoalPlanName: GoalPlanName
                },
                captions: captions,
                action: 1,
                ModuleID: "D39",
                TransID: GoalPlanID,
                TransactionID: "W39F3036",
                TransactionName: "Chi tiết xếp loại đánh giá nhân viên",
                itemRender: (e, type) => {
                    const { data, oldData, key } = e;
                    if (type === 'Content_DETAIL_NEW' || type === 'Content_DETAIL_OLD' || type === 'Content_DETAIL') {
                        const isCombo = column.find(rs => rs.RefID === key && rs.GroupMode === 0)
                        if (isCombo) {
                            const _data = (type === 'Content_DETAIL' || type === 'Content_DETAIL_NEW') ? data[key] : oldData[key];
                            const item = cbEvaluationType.find(rs => rs.Value === _data);
                            return item?.EvaluationTypeName ?? _data;
                        }
                    }
                }
            };
            const history = new History(options);
            //Tao detail cho tham chieu xep loai
            history.createDetailHistory("Tham_chieu_xep_loai", _dataSource, oldDataSouce.current, captionTCXL, "EmployeeID", null, options);
            //Tao detail cho tham chieu so
            history.createDetailHistory("Tham_chieu_so", _dataSource, oldDataSouce.current, captionTCS, "EmployeeID", null, options);
            //Tao detail cho tham chieu chuoi
            history.createDetailHistory("Tham_chieu_chuoi", _dataSource, oldDataSouce.current, captionC, "EmployeeID", null, options);
            if (history.get().length > 0) {
                await history.save();
            }
        } else {
            Config.notify.show("error", Config.lang("Luu_lich_su_khong_thanh_cong"), 2000);
        }
    }

    const removeDuplicates = (arr, key) => {
        return arr.reduce((unique, o) => {
            if (!unique.some(obj => obj[key] === o[key]) && o[key]) {
                unique.push(o);
            }
            return unique;
        }, []);
    }

    const groupByField = (array, key) => {
        return array.reduce((group, item) => {
            if (Object.keys(group).includes(item[key])) {
                group[item[key]].data = group[item[key]].data.concat(item);
            } else {
                group[item[key]] = {
                    SCRefID: item[key],
                    SCRefName: item['SCRefName'],
                    data: [item],
                };
            }
            return group;
        }, {})
    }

    const onBack = () => {
        if (isUpdated) {
            Config.popup.show("YES_NO", Config.lang('Du_lieu_chua_duoc_luu_Ban_co_muon_luu_khong'), () => {
                onSave(true)
            }, () => {
                browserHistory.goBack();
            })
        } else {
            browserHistory.goBack();
        }
    }

    const getStructure = (columns) => {
        const structure = [];
        columns.forEach(column => {
            structure.push({
                fieldName: column.dataField,
                caption: column.caption,
                visible: column.visible,
                width: Math.round(column.visibleWidth)
            })
        });
        return structure;
    }

    const onExport = async () => {
        const dataSource = refRateGrid.current.dataGrid.instance.option("dataSource");
        if (dataSource) {
            const dataExport = [];
            const columnsGrid1 = refRateGrid.current.dataGrid.instance.getVisibleColumns();
            const grid1 = JSON.parse(JSON.stringify(dataSource)).map(rs => {
                column.forEach(c => {
                    if (typeof rs[c.RefID] !== 'undefined' && c.GroupMode === 0) {
                        const rowData = cbEvaluationType.find(item => item.Value === rs[c.RefID]);
                        rs[c.RefID] = rowData?.EvaluationTypeName ?? '';
                    }
                })
                return rs;
            });
            dataExport.push({
                title: GoalPlanName,
                grid: grid1,
                structure: getStructure(columnsGrid1)
            });
            const dataSourceStatistic = refStatisticGrid.current.dataGrid.instance.option("dataSource");
            if (dataSourceStatistic) {
                const columnsGrid2 = refStatisticGrid.current.dataGrid.instance.getVisibleColumns();
                dataExport.push({
                    title: Config.lang('Thong_ke'),
                    grid: dataSourceStatistic,
                    structure: getStructure(columnsGrid2)
                });
            }
            const params = {
                titleForm: Config.lang('Chi_tiet_xep_loai_danh_gia_nhan_vien'),
                filename: Config.lang('Chi_tiet_xep_loai_danh_gia_nhan_vien'),
                data: JSON.stringify(dataExport)
            };
            dispatch(W39F3036Actions.onExport(params, (error, dataFile) => {
                if (error) {
                    Config.popup.show("ERROR", error);
                    setLoading(false);
                    return false;
                }
                const link = document.createElement("a");
                link.href = dataFile?.URL ?? "";
                link.download = dataFile.fileName ? decodeURI(dataFile.fileName) : "";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Config.notify.show("success", Config.lang("Xuat_du_lieu_thanh_cong"), 3000);
            }));
        } else {
            Config.popup.show('INFO', Config.lang("No_data"))
        }
    }

    const { GoalPlanID, mode, IsTransferred, GoalPlanName } = getInfo();
    if (!getInfo(true)) return null;

    const disabled = mode === 'view' || iPermission.W39F3035 < 2 || IsTransferred === 1;
    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ my: 'center', of: "#root" }}
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
            />
            <div className={"hidden"}>{renderFilterData()}</div>
            <div className="mgb15">
                <ActionToolbar allwaysTop title={Config.lang('Chi_tiet_xep_loai_danh_gia_nhan_vien')} onBack={onBack}
                    alignment={"flex-end"}>
                    <ButtonIcon name="Sheet" viewType="text" color="success" onClick={onExport} />
                    <Button viewType="filled" startIcon="save" color='info' label={Config.lang("Luu")}
                        disabled={disabled || !isUpdated}
                        onClick={() => onSave()} />
                </ActionToolbar>
            </div>
            <div className="pdb10">
                <GridContainer
                    ref={refRateGrid}
                    dataSource={dataSource}
                    showBorders={true}
                    typePaging={"normal"}
                    keyExpr="EmployeeID"
                    pagerFullScreen={false}
                    showColumnLines={false}
                    showRowLines={false}
                    hoverStateEnabled={true}
                    height={400}
                    editing={{
                        mode: "cell",
                        refreshMode: "reshape",
                        allowUpdating: !disabled,
                        texts: {
                            confirmDeleteMessage: "",
                        },
                    }}
                    onRowUpdated={e => {
                        setIsUpdated(true);
                    }}
                    elementAttr={{
                        class: classes.statisticGrid
                    }}

                >
                    <Column dataField={"STT"} alignment='center' caption={Config.lang("STT")} allowEditing={false} />
                    <Column dataField={"EmployeeID"} caption={Config.lang("Ma_nhan_vien")} cellRender={cellRenderEmloyee} allowEditing={false} />
                    <Column dataField={"EmployeeName"} caption={Config.lang("Ten_nhan_vien")} allowEditing={false} />
                    <Column dataField={"OrgChartName"} caption={Config.lang("Co_cau_to_chuc")} allowEditing={false} />
                    <Column dataField={"DutyName"} caption={Config.lang("Chuc_danh")} allowEditing={false} />
                    <Column dataField={"ResultFinal"} caption={Config.lang("Ket_qua")} allowEditing={false} />
                    <Column dataField={"EvaluationTypeName"} caption={Config.lang("Xep_loai")} allowEditing={false} />
                    {renderColumn()}
                </GridContainer>
            </div>
            <label>{Config.lang('Thong_ke')}</label>
            <GridContainer
                ref={refStatisticGrid}
                dataSource={dataSourceStatistic}
                showBorders={true}
                showColumnLines={false}
                showRowLines={false}
                hoverStateEnabled={true}
                typePaging={"normal"}
                pagerFullScreen={false}
                elementAttr={{
                    class: classes.statisticGrid
                }}
            >
                <Column dataField={"SCRefName"} caption={Config.lang("Thong_tin_xep_loai")} />
                {renderColumnStatistic()}
                <Column dataField={"STotal"} caption={Config.lang("Tong_cong")} alignment="right" dataType="number" />
            </GridContainer>
        </div>
    );
};

export default W39F3036;